import React, { useEffect, useState } from "react";
import { segExonerado } from "../../config/constantes";
import useAuth from "../../hooks/useAuth";
import useMatricula from "../../hooks/useMatricula";
import useProcesoMatricula from "../../hooks/useProcesoMatricula";
import { update_paso } from "../../services/procesoMatricula/procesoMatricula";
import { obtenerLabelEtiqueta } from "../../utils/idioma/LabelsIdioma";

const ModalExonerado = () => {
  let segundos = segExonerado;
  let [minutosCodigo, setMinutosCodigo] = useState(0);
  let [segundosCodigo, setSegundosCodigo] = useState(segundos);
  let { obtenerDatosEstudiante, gruposHabilitados } = useMatricula();
  let { setLoading, setPasoProcesoM, setPasoSegundaVistaProcesoM } = useProcesoMatricula();

  const { becado } = obtenerDatosEstudiante;

  const { listadoEtiquetas } = useAuth();
  const [etiquetas, setEtiquetas] = useState({});

  useEffect(() => {
    if (listadoEtiquetas.length > 0) {
      setEtiquetas({
        lbl_pago_msj_exonerado: obtenerLabelEtiqueta(
          "lbl_pago_msj_exonerado",
          listadoEtiquetas
        ),
        lbl_pago_msj_sistema: obtenerLabelEtiqueta(
          "lbl_pago_msj_sistema",
          listadoEtiquetas
        ),
        lbl_pago_segundos: obtenerLabelEtiqueta(
          "lbl_pago_segundos",
          listadoEtiquetas
        ),
        lbl_update_datos_continuar: obtenerLabelEtiqueta(
          "lbl_update_datos_continuar",
          listadoEtiquetas
        )

      });
    }
  }, [listadoEtiquetas]);
  const { lbl_pago_msj_exonerado,
    lbl_update_datos_continuar, lbl_pago_segundos, lbl_pago_msj_sistema } = etiquetas;



  useEffect(() => {

    if (becado) {

      let sampleInterval = setInterval(() => {
        if (segundosCodigo > 0) {
          setSegundosCodigo(segundosCodigo - 1);
        }
        if (segundosCodigo === 0) {
          if (minutosCodigo === 0) {
            clearInterval(sampleInterval);
          } else {
            setMinutosCodigo(minutosCodigo - 1);
            setSegundosCodigo(59);
          }
        }
      }, 1000);
      return () => {
        clearInterval(sampleInterval);
      };
    }
  }, [segundosCodigo, obtenerDatosEstudiante]);

  useEffect(() => {
    setSegundosCodigo(segundos);
  }, [obtenerDatosEstudiante]);
  useEffect(() => {
    setSegundosCodigo(segundos);
  }, []);

  useEffect(() => {
    let modalExoneradCerrar = document.querySelector("#cerrarExonerado");
    if (segundosCodigo == 0) {
      if (becado == true) {
        if (modalExoneradCerrar) {

          (async () => {
            try {
              setLoading(true);
              //Primero validar
              await update_paso(obtenerDatosEstudiante, 5, 2);
              //Despues setear los campos de estado
              setPasoProcesoM(5);
              setPasoSegundaVistaProcesoM(true);
              modalExoneradCerrar.click();
            } catch (error) {
            } finally {
              setLoading(false);
            }
          })();
        }

      }
    }
  }, [segundosCodigo]);

  let handleNext = async () => {
    if (becado == true) {
      try {
        setLoading(true);

        await update_paso(obtenerDatosEstudiante, 5, 2);

        setPasoProcesoM(5);
        setPasoSegundaVistaProcesoM(true);
      } catch (error) {
      } finally {
        setLoading(false);
      }
    }
  }
  return (
    <div
      className="modal fade"
      id="exonerado"
      tabIndex={-1}
      data-bs-backdrop="static"
      aria-labelledby="exampleModalLabel1"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header border-bottom-0 d-none">
            <h5 className="modal-title" id="exampleModalLabel1" />
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            />
          </div>
          <div className="modal-body pb-0 pt-4">
            <div className="text-center mt-3">
              <h5 className="text-uppercase mb-3">
                {lbl_pago_msj_exonerado}
              </h5>
              <p>
                {`${lbl_pago_msj_sistema} ${segundosCodigo} ${lbl_pago_segundos}...`}

              </p>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-primary"
              onClick={handleNext}
              data-bs-dismiss="modal"
              aria-label="Close"
              id="cerrarExonerado"
            >
              {lbl_update_datos_continuar}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalExonerado;
